import httpClient from '@/http-client'

export const visitation = data => {
  return httpClient
    .post('/api/v1/reports/sale/visitation-plans', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const visitationExcel = data => {
  return httpClient
    .post('/api/v1/reports/sale/visitation-plans/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const user = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/sale/visitation-plans/users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const detailSaleByProduct = data => {
  return httpClient
    .get('/api/v1/reports/sale/detail-sale-by-products', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const detailSaleByProductExcel = data => {
  return httpClient
    .post('/api/v1/reports/sale/detail-sale-by-products/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const detailStockReturnByProduct = data => {
  return httpClient
    .get('/api/v1/reports/sale/detail-stock-return-by-products', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const detailStockReturnByProductExcel = data => {
  return httpClient
    .post('/api/v1/reports/sale/detail-stock-return-by-products/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const detailSaleByCustomer = data => {
  return httpClient
    .get('/api/v1/reports/sale/detail-sale-by-customers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const detailSaleByCustomerExcel = data => {
  return httpClient
    .post('/api/v1/reports/sale/detail-sale-by-customers/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const detailSaleByImei = data => {
  return httpClient
    .get('/api/v1/reports/sale/detail-sale-by-imeis', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const detailSaleByImeiExcel = data => {
  return httpClient
    .post('/api/v1/reports/sale/detail-sale-by-imeis/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  visitation,
  visitationExcel,
  user,
  detailSaleByProduct,
  detailSaleByProductExcel,
  detailStockReturnByProduct,
  detailStockReturnByProductExcel,
  detailSaleByCustomer,
  detailSaleByCustomerExcel,
  detailSaleByImei,
  detailSaleByImeiExcel
}